module.exports = __webpack_public_path__ + "static/media/malcolm.3a9c8294.jpg";